import React from 'react';
import { Alert } from '@mui/material';
import { format } from 'date-fns';
import { api_auth } from '../../../../common/globals/constants';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import EventsMeasurements from '../../../../components/IndividualCharts/EventsMeasurements/EventsMeasurements';
import { useFetchEventsMeasurements } from '../../hooks/useFetchEventsMeasurements';
import { useDynamicViewState } from '../../context/dynamic-view-context';

const URL_PARAMS = ({ objetivoId, periodo }) => {
  let fechaInicio = '';
  let fechaTermino = '';

  if (periodo.period === 'c') {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }

  const token = sessionStorage.getItem('key');

  const URL = new URLSearchParams();
  URL.append('objetivoId', objetivoId);
  URL.append('token', token);
  URL.append('key', api_auth);
  URL.append('horarioId', '0');

  if (periodo.period === 'c') {
    URL.append('fechaInicio', fechaInicio);
    URL.append('fechaTermino', fechaTermino);
    URL.append('nodoId', '0');
  } else {
    URL.append('t', periodo.period);
  }

  return URL;
};

const EventsMeasurementsChart = ({ objetivoId }) => {
  const { filterPeriod, refreshTime } = useDynamicViewState();

  const fetchApi =
    filterPeriod.period === 'c'
      ? 'getResultadosObjetivoEstadisticaCustom'
      : 'getResultadosObjetivoEstadistica';

  const { data, isLoading, error, isFetching } = useFetchEventsMeasurements({
    urlParams: URL_PARAMS({ objetivoId, periodo: filterPeriod }),
    fetchApi,
    refreshTime,
  });

  if (isLoading || isFetching) return <AtCircularProgress />;
  if (error) return <Alert severity="error">Error al cargar los datos.</Alert>;

  return <EventsMeasurements externalData={data} isLoading={isLoading} />;
};

export default React.memo(EventsMeasurementsChart);
